import { IApiRole } from '@styluxinc/api-schema';

type AtLeastTwo<T> = [T, T, ...T[]];

export type IResource =
  | 'DASHBOARD'
  | 'ORDERS'
  | 'INVENTORY'
  | 'OFFERS'
  | 'PRODUCTS'
  | 'SETTINGS'
  | 'B2B_ORDERS';

export const RESOURCE_TO_ROLE_MAP: Record<IResource, IApiRole[]> = {
  // page not implemented yet
  DASHBOARD: [],
  // page not implemented yet
  PRODUCTS: [],
  ORDERS: [
    'Stylux Internal Super Admin',
    'SUPER_ADMIN',
    'MERCHANT_ORDERS',
    'PARTNER_ORDERS',
    'THIRD_PARTY_SUPPORT_ORDERS',
  ],
  INVENTORY: [
    'Stylux Internal Super Admin',
    'SUPER_ADMIN',
    'MERCHANT_INVENTORY',
    'PARTNER_INVENTORY',
    'THIRD_PARTY_SUPPORT_INVENTORY',
  ],
  OFFERS: [
    'Stylux Internal Super Admin',
    'SUPER_ADMIN',
    'MERCHANT_OFFERS',
    'PARTNER_OFFERS',
    'THIRD_PARTY_SUPPORT_OFFERS',
  ],
  SETTINGS: ['SUPER_ADMIN', 'Stylux Internal Super Admin'],
  B2B_ORDERS: [
    'Stylux Internal Super Admin',
    'SUPER_ADMIN',
    // TODO: support b2b order roles when available
  ],
};

export const ROLE_TO_RESOURCE_MAP: Record<IApiRole, IResource[]> =
  Object.entries(RESOURCE_TO_ROLE_MAP).reduce(
    (acc, [resource, roles]) => {
      roles.forEach((role) => {
        acc[role] = acc[role] ?? [];
        acc[role].push(resource as IResource);
      });
      return acc;
    },
    {} as Record<IApiRole, IResource[]>,
  );

export const DECORATOR_ROLES: AtLeastTwo<IApiRole> = [
  'PARTNER_ORDERS',
  'PARTNER_INVENTORY',
  'PARTNER_OFFERS',
];

export const THIRD_PARTY_ROLES: AtLeastTwo<IApiRole> = [
  'THIRD_PARTY_SUPPORT_ORDERS',
  'THIRD_PARTY_SUPPORT_INVENTORY',
  'THIRD_PARTY_SUPPORT_OFFERS',
];

export const MERCHANT_ROLES: AtLeastTwo<IApiRole> = [
  'MERCHANT_ORDERS',
  'MERCHANT_INVENTORY',
  'MERCHANT_OFFERS',
];

export const SUPER_ADMIN_ROLES: AtLeastTwo<IApiRole> = [
  'SUPER_ADMIN',
  // @deprecated - remove this once we've migrated to the new role
  'Stylux Internal Super Admin',
];
